import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { Footer } from '../../Components/Footer';
import {
  useBillSummaryDetailsQuery,
  usePreRegistrationPreAuthCreateMutation,
} from '../../generated/graphql';
import SnackBarMsg from '../../Components/SnackBar/SnackBarMsg';
import { useSnackBar } from '../../Components/Hooks/useSnackBar';
import Loading from '../../Components/Loading/Loading';
import { amtStr } from '../../Components/helper/numFormatter';
import { PaymentUrl } from './Payment';

export const PreAuthorisation = ({ RegistrationDetails }) => {
  const { snackFunc, snackBarMessage, openSnackBar } = useSnackBar();

  const selectedRoomID = JSON.parse(localStorage.getItem('SelectedRoom') as any)?.ID;

  const {
    loading: BillSummaryDetailsLoadings,
    data: { BillSummaryDetails } = { BillSummaryDetails: null },
  } = useBillSummaryDetailsQuery({
    variables: {
      BillSummaryInput: {
        HotelID: RegistrationDetails?.Booking?.HotelID,
        RegistrationID: RegistrationDetails?.ID,
        ArrivalDate: RegistrationDetails?.ArrivalDate,
        DepartureDate: RegistrationDetails?.DepartureDate,
        IsChooseRoom: selectedRoomID ? true : false,
        RoomID: selectedRoomID ? selectedRoomID : undefined,
      },
    },
    fetchPolicy: 'no-cache',
  });

  const [PreRegistrationPreAuthCreate, { loading }] =
    usePreRegistrationPreAuthCreateMutation();

  // display only; backend resolvePreAuthAmount sets the actual hold from Hotel.SecurityDeposit
  const holdAmount = Number(BillSummaryDetails?.SecurityDeposit || 0);

  const startPreAuth = () => {
    PreRegistrationPreAuthCreate({
      variables: {
        HotelID: RegistrationDetails?.Booking?.HotelID,
        BookingID: RegistrationDetails?.Booking?.ID,
        RegistrationID: RegistrationDetails?.ID,
        redirectUrl: PaymentUrl,
        Name: RegistrationDetails?.Guest?.Contact?.FullName,
        Email: RegistrationDetails?.Guest?.Contact?.Email,
        MobileNumber: RegistrationDetails?.Guest?.Contact?.MobileNo,
      },
    }).then(result => {
      const payload = result.data?.PreRegistrationPreAuthCreate;
      if (
        payload?.code === 'SUCCESS' &&
        payload?.item?.url &&
        payload?.PaymentAttemptID &&
        payload?.RequestRef
      ) {
        localStorage.setItem('PreAuthAttemptID', payload.PaymentAttemptID);
        localStorage.setItem('PreAuthRequestRef', payload.RequestRef);
        localStorage.setItem('CheckOutID', payload.item.checkoutId!);
        localStorage.setItem('RegistrationDetails', JSON.stringify(RegistrationDetails));
        window.location.href = payload.item.url!;
      } else {
        payload?.error?.message
          ? snackFunc(payload.error.message, false)
          : snackFunc('Pre-authorization failed', false);
      }
    }).catch(() => {
      snackFunc('Pre-authorization failed', false);
    });
  };

  if (loading || BillSummaryDetailsLoadings) {
    return <Loading />;
  }

  return (
    <>
      <Box>
        <Card
          sx={{
            borderRadius: '5px',
            boxShadow:
              '0 3px 1px -2px transparent, 2px 4px 4px -2px rgb(0 0 0 / 15%), -2px -1px 4px -2px rgb(0 0 0 / 15%)',
          }}
        >
          <CardContent sx={{ ':last-child': { p: '16px' } }}>
            <Typography fontSize="14px" fontWeight={600} mb="12px">
              Pre-Authorisation
            </Typography>
            <Typography fontSize="13px" color="text.secondary" mb="16px">
              A temporary hold will be placed on your card. No charge is taken until the hotel captures it.
            </Typography>
            <Box width="100%" display="flex" style={{ borderBottom: '1px solid #ccc', marginBottom: '5px' }}>
              <Box width="50%" display="flex" style={{ marginBottom: '5px' }}>
                <Typography fontSize="12px" fontWeight={600} align="left">
                  Pre-Authorisation Amount
                </Typography>
              </Box>
              <Box width="50%" display="flex" sx={{ flexDirection: 'row-reverse' }}>
                <Typography fontSize="12px" fontWeight={600}>
                  {amtStr(holdAmount)}
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Box>
      <Footer
        primary={true}
        options={[
          {
            name: 'Authorize',
            onClick: startPreAuth,
          },
        ]}
      />
      <SnackBarMsg open={openSnackBar} message={snackBarMessage} />
    </>
  );
};
